import * as type from '../constants/ActionTypes';

export default function registerAppUser(
  state = {
    isRegistering: false
  },
  action
) {
  switch (action.type) {
    case type.APP_USER_POST_REQUEST:
      return Object.assign({}, state, {
        isRegistering: true
      });
    case type.APP_USER_POST_SUCCESS:
      return Object.assign({}, state, {
        isRegistering: false
      });
    case type.APP_USER_POST_FAILURE:
      return Object.assign({}, state, {
        isRegistering: false
      });
    default:
      return state;
  }
}